
import * as React from 'react';
import { ICommand } from '../../../../models/commands/ICommand';
import { ResolveProgressAction } from '../../actions/resolve/ResolveProgressAction';
import { Facet } from '../../../../models/Facet';
import ProgressStrings from '../../ProgressStrings.resx';

export const replaceProgressCommand: ICommand = {
  key: new Facet('renameProgressCommand').id,
  name: ProgressStrings.progressReplaceActionText,
  action: <ResolveProgressAction conflictResolution='replace' />
};
